module.exports = __webpack_public_path__ + "static/img/home-hero.e450f15.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/home-hero.jpg
// module id = mkhW
// module chunks = 1